
import { SWRConfiguration, SWRResponse } from "swr";

import { IReturn, GetTrialSourceDataStatuses, QuerySourceDataStatusesResponse, Trial, SourceDataStatus } from "@/api/dtos";
import { useMemo } from "react";
import useGet from "@/hooks/api/useGet";

const getData = (response?: SWRResponse<QuerySourceDataStatusesResponse, QuerySourceDataStatusesResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<QuerySourceDataStatusesResponse, QuerySourceDataStatusesResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<QuerySourceDataStatusesResponse, QuerySourceDataStatusesResponse>) => ({
    idMap: response?.data?.data?.reduce<Record<number, SourceDataStatus>>((a, b) => {
        if (!b?.trialId) {
            return a;
        }
        
        a[b.trialId] = b;

        return a;
    },{})
});

export const useTrialStatuses = (configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        return () => {
            return new GetTrialSourceDataStatuses();
        }
    }, []);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useTrialStatuses;